class SwiperControls extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.swiperContainer = this.closest('swiper-container');
    
    if (!this.swiperContainer) {
      return;
    }
    
    this.prevButton = this.querySelector('.btn-prev');
    this.nextButton = this.querySelector('.btn-next');

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.swiperContainer.swiper.slidePrev();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.swiperContainer.swiper.slideNext();
      });
    }
  }
}
if (!customElements.get('swiper-controls')) customElements.define('swiper-controls', SwiperControls);